declare global {
    interface Window {
        // @ts-expect-error
        // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
        dataLayer?: any[];
    }
}

export const GAEventTrigger = {
    click: 'click',
    visibility: 'visibility',
} as const;

export type GAEventTrigger = (typeof GAEventTrigger)[keyof typeof GAEventTrigger];

export const GAFlowName = {
    easyOnboardingFlow: 'easyOnboardingFlow',
} as const;

export type GAFlowName = (typeof GAFlowName)[keyof typeof GAFlowName];

export const GAEventName = {
    selectAddAsset: 'select_add_asset',
    selectAssetType: 'select_vehicle_type',
    selectBrand: 'select_brand',
    selectTelematics: 'select_telematics',
    selectTelematicsGroup: 'select_telematics_group',
} as const;

export type GAEventName = (typeof GAEventName)[keyof typeof GAEventName];

interface UserProperties {
    accountId?: string;
    tenant?: string;
}

interface UserEvent {
    trigger: GAEventTrigger;
    event: GAEventName | string;
    element_name?: string;
    flow_name?: GAFlowName | string;
}

export const useGoogleAnalytics = () => {
    const dataLayerPush = (event: UserEvent | UserProperties) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ...event });
    };
    return { dataLayerPush };
};
